const THREE = require("three");
const v6428 = /^[og]\s*(.+)?/;
const v6429 = /^mtllib /;
const v6430 = /^usemtl /;
const v6431 = /^usemap /;
const v6432 = /\s+/;
const v6433 = new THREE.Vector3();
const v6434 = new THREE.Vector3();
const v6435 = new THREE.Vector3();
const v6436 = new THREE.Vector3();
const v6437 = new THREE.Vector3();
const v6438 = new THREE.Color();
function f1133() {
  const vO188 = {
    objects: [],
    object: {},
    vertices: [],
    normals: [],
    colors: [],
    uvs: [],
    materials: {},
    materialLibraries: [],
    startObject: function (p7696, p7697) {
      if (this.object && this.object.fromDeclaration === false) {
        this.object.name = p7696;
        this.object.fromDeclaration = p7697 !== false;
        return;
      }
      const v6439 = this.object && typeof this.object.currentMaterial === "function" ? this.object.currentMaterial() : undefined;
      if (this.object && typeof this.object._finalize === "function") {
        this.object._finalize(true);
      }
      this.object = {
        name: p7696 || "",
        fromDeclaration: p7697 !== false,
        geometry: {
          vertices: [],
          normals: [],
          colors: [],
          uvs: [],
          hasUVIndices: false
        },
        materials: [],
        smooth: true,
        startMaterial: function (p7698, p7699) {
          const v6440 = this._finalize(false);
          if (v6440 && (v6440.inherited || v6440.groupCount <= 0)) {
            this.materials.splice(v6440.index, 1);
          }
          const vO189 = {
            index: this.materials.length,
            name: p7698 || "",
            mtllib: Array.isArray(p7699) && p7699.length > 0 ? p7699[p7699.length - 1] : "",
            smooth: v6440 !== undefined ? v6440.smooth : this.smooth,
            groupStart: v6440 !== undefined ? v6440.groupEnd : 0,
            groupEnd: -1,
            groupCount: -1,
            inherited: false,
            clone: function (p7700) {
              const vO190 = {
                index: typeof p7700 === "number" ? p7700 : this.index,
                name: this.name,
                mtllib: this.mtllib,
                smooth: this.smooth,
                groupStart: 0,
                groupEnd: -1,
                groupCount: -1,
                inherited: false
              };
              vO190.clone = this.clone.bind(vO190);
              return vO190;
            }
          };
          this.materials.push(vO189);
          return vO189;
        },
        currentMaterial: function () {
          if (this.materials.length > 0) {
            return this.materials[this.materials.length - 1];
          }
          return undefined;
        },
        _finalize: function (p7701) {
          const v6441 = this.currentMaterial();
          if (v6441 && v6441.groupEnd === -1) {
            v6441.groupEnd = this.geometry.vertices.length / 3;
            v6441.groupCount = v6441.groupEnd - v6441.groupStart;
            v6441.inherited = false;
          }
          if (p7701 && this.materials.length > 1) {
            for (let v6442 = this.materials.length - 1; v6442 >= 0; v6442--) {
              if (this.materials[v6442].groupCount <= 0) {
                this.materials.splice(v6442, 1);
              }
            }
          }
          if (p7701 && this.materials.length === 0) {
            this.materials.push({
              name: "",
              smooth: this.smooth
            });
          }
          return v6441;
        }
      };
      if (v6439 && v6439.name && typeof v6439.clone === "function") {
        const v6443 = v6439.clone(0);
        v6443.inherited = true;
        this.object.materials.push(v6443);
      }
      this.objects.push(this.object);
    },
    finalize: function () {
      if (this.object && typeof this.object._finalize === "function") {
        this.object._finalize(true);
      }
    },
    parseVertexIndex: function (p7702, p7703) {
      const vParseInt9 = parseInt(p7702, 10);
      return (vParseInt9 >= 0 ? vParseInt9 - 1 : vParseInt9 + p7703 / 3) * 3;
    },
    parseNormalIndex: function (p7704, p7705) {
      const vParseInt10 = parseInt(p7704, 10);
      return (vParseInt10 >= 0 ? vParseInt10 - 1 : vParseInt10 + p7705 / 3) * 3;
    },
    parseUVIndex: function (p7706, p7707) {
      const vParseInt11 = parseInt(p7706, 10);
      return (vParseInt11 >= 0 ? vParseInt11 - 1 : vParseInt11 + p7707 / 2) * 2;
    },
    addVertex: function (p7708, p7709, p7710) {
      const v6444 = this.vertices;
      const v6445 = this.object.geometry.vertices;
      v6445.push(v6444[p7708 + 0], v6444[p7708 + 1], v6444[p7708 + 2]);
      v6445.push(v6444[p7709 + 0], v6444[p7709 + 1], v6444[p7709 + 2]);
      v6445.push(v6444[p7710 + 0], v6444[p7710 + 1], v6444[p7710 + 2]);
    },
    addVertexPoint: function (p7711) {
      const v6446 = this.vertices;
      const v6447 = this.object.geometry.vertices;
      v6447.push(v6446[p7711 + 0], v6446[p7711 + 1], v6446[p7711 + 2]);
    },
    addVertexLine: function (p7712) {
      const v6448 = this.vertices;
      const v6449 = this.object.geometry.vertices;
      v6449.push(v6448[p7712 + 0], v6448[p7712 + 1], v6448[p7712 + 2]);
    },
    addNormal: function (p7713, p7714, p7715) {
      const v6450 = this.normals;
      const v6451 = this.object.geometry.normals;
      v6451.push(v6450[p7713 + 0], v6450[p7713 + 1], v6450[p7713 + 2]);
      v6451.push(v6450[p7714 + 0], v6450[p7714 + 1], v6450[p7714 + 2]);
      v6451.push(v6450[p7715 + 0], v6450[p7715 + 1], v6450[p7715 + 2]);
    },
    addFaceNormal: function (p7716, p7717, p7718) {
      const v6452 = this.vertices;
      const v6453 = this.object.geometry.normals;
      v6433.fromArray(v6452, p7716);
      v6434.fromArray(v6452, p7717);
      v6435.fromArray(v6452, p7718);
      v6437.subVectors(v6435, v6434);
      v6436.subVectors(v6433, v6434);
      v6437.cross(v6436);
      v6437.normalize();
      v6453.push(v6437.x, v6437.y, v6437.z);
      v6453.push(v6437.x, v6437.y, v6437.z);
      v6453.push(v6437.x, v6437.y, v6437.z);
    },
    addColor: function (p7719, p7720, p7721) {
      const v6454 = this.colors;
      const v6455 = this.object.geometry.colors;
      if (v6454[p7719] !== undefined) {
        v6455.push(v6454[p7719 + 0], v6454[p7719 + 1], v6454[p7719 + 2]);
      }
      if (v6454[p7720] !== undefined) {
        v6455.push(v6454[p7720 + 0], v6454[p7720 + 1], v6454[p7720 + 2]);
      }
      if (v6454[p7721] !== undefined) {
        v6455.push(v6454[p7721 + 0], v6454[p7721 + 1], v6454[p7721 + 2]);
      }
    },
    addUV: function (p7722, p7723, p7724) {
      const v6456 = this.uvs;
      const v6457 = this.object.geometry.uvs;
      v6457.push(v6456[p7722 + 0], v6456[p7722 + 1]);
      v6457.push(v6456[p7723 + 0], v6456[p7723 + 1]);
      v6457.push(v6456[p7724 + 0], v6456[p7724 + 1]);
    },
    addDefaultUV: function () {
      const v6458 = this.object.geometry.uvs;
      v6458.push(0, 0);
      v6458.push(0, 0);
      v6458.push(0, 0);
    },
    addUVLine: function (p7725) {
      const v6459 = this.uvs;
      const v6460 = this.object.geometry.uvs;
      v6460.push(v6459[p7725 + 0], v6459[p7725 + 1]);
    },
    addFace: function (p7726, p7727, p7728, p7729, p7730, p7731, p7732, p7733, p7734) {
      const v6461 = this.vertices.length;
      let v6462 = this.parseVertexIndex(p7726, v6461);
      let v6463 = this.parseVertexIndex(p7727, v6461);
      let v6464 = this.parseVertexIndex(p7728, v6461);
      this.addVertex(v6462, v6463, v6464);
      this.addColor(v6462, v6463, v6464);
      if (p7732 !== undefined && p7732 !== "") {
        const v6465 = this.normals.length;
        v6462 = this.parseNormalIndex(p7732, v6465);
        v6463 = this.parseNormalIndex(p7733, v6465);
        v6464 = this.parseNormalIndex(p7734, v6465);
        this.addNormal(v6462, v6463, v6464);
      } else {
        this.addFaceNormal(v6462, v6463, v6464);
      }
      if (p7729 !== undefined && p7729 !== "") {
        const v6466 = this.uvs.length;
        v6462 = this.parseUVIndex(p7729, v6466);
        v6463 = this.parseUVIndex(p7730, v6466);
        v6464 = this.parseUVIndex(p7731, v6466);
        this.addUV(v6462, v6463, v6464);
        this.object.geometry.hasUVIndices = true;
      } else {
        this.addDefaultUV();
      }
    },
    addPointGeometry: function (p7735) {
      this.object.geometry.type = "Points";
      const v6467 = this.vertices.length;
      for (let vLN01029 = 0, v6468 = p7735.length; vLN01029 < v6468; vLN01029++) {
        const v6469 = this.parseVertexIndex(p7735[vLN01029], v6467);
        this.addVertexPoint(v6469);
        this.addColor(v6469);
      }
    },
    addLineGeometry: function (p7736, p7737) {
      this.object.geometry.type = "Line";
      const v6470 = this.vertices.length;
      const v6471 = this.uvs.length;
      for (let vLN01030 = 0, v6472 = p7736.length; vLN01030 < v6472; vLN01030++) {
        this.addVertexLine(this.parseVertexIndex(p7736[vLN01030], v6470));
      }
      for (let vLN01031 = 0, v6473 = p7737.length; vLN01031 < v6473; vLN01031++) {
        this.addUVLine(this.parseUVIndex(p7737[vLN01031], v6471));
      }
    }
  };
  vO188.startObject("", false);
  return vO188;
}
export class OBJLoader extends THREE.Loader {
  constructor(p7738) {
    super(p7738);
    this.materials = null;
  }
  load(p7739, p7740, p7741, p7742) {
    const vThis51 = this;
    const v6474 = new THREE.FileLoader(this.manager);
    v6474.setPath(this.path);
    v6474.setRequestHeader(this.requestHeader);
    v6474.setWithCredentials(this.withCredentials);
    v6474.load(p7739, function (p7743) {
      try {
        p7740(vThis51.parse(p7743));
      } catch (e68) {
        if (p7742) {
          p7742(e68);
        } else {
          console.error(e68);
        }
        vThis51.manager.itemError(p7739);
      }
    }, p7741, p7742);
  }
  setMaterials(p7744) {
    this.materials = p7744;
    return this;
  }
  parse(p7745) {
    const v6475 = new f1133();
    if (p7745.indexOf("\r\n") !== -1) {
      p7745 = p7745.replace(/\r\n/g, "\n");
    }
    if (p7745.indexOf("\\\n") !== -1) {
      p7745 = p7745.replace(/\\\n/g, "");
    }
    const v6476 = p7745.split("\n");
    let vA349 = [];
    for (let vLN01032 = 0, v6477 = v6476.length; vLN01032 < v6477; vLN01032++) {
      const v6478 = v6476[vLN01032].trimStart();
      if (v6478.length === 0) {
        continue;
      }
      const v6479 = v6478.charAt(0);
      if (v6479 === "#") {
        continue;
      }
      if (v6479 === "v") {
        const v6480 = v6478.split(v6432);
        switch (v6480[0]) {
          case "v":
            v6475.vertices.push(parseFloat(v6480[1]), parseFloat(v6480[2]), parseFloat(v6480[3]));
            if (v6480.length >= 7) {
              v6438.setRGB(parseFloat(v6480[4]), parseFloat(v6480[5]), parseFloat(v6480[6])).convertSRGBToLinear();
              v6475.colors.push(v6438.r, v6438.g, v6438.b);
            } else {
              v6475.colors.push(undefined, undefined, undefined);
            }
            break;
          case "vn":
            v6475.normals.push(parseFloat(v6480[1]), parseFloat(v6480[2]), parseFloat(v6480[3]));
            break;
          case "vt":
            v6475.uvs.push(parseFloat(v6480[1]), parseFloat(v6480[2]));
            break;
        }
      } else if (v6479 === "f") {
        const v6481 = v6478.slice(1).trim();
        const v6482 = v6481.split(v6432);
        const vA350 = [];
        for (let vLN01033 = 0, v6483 = v6482.length; vLN01033 < v6483; vLN01033++) {
          const v6484 = v6482[vLN01033];
          if (v6484.length > 0) {
            const v6485 = v6484.split("/");
            vA350.push(v6485);
          }
        }
        const v6486 = vA350[0];
        for (let vLN1102 = 1, v6487 = vA350.length - 1; vLN1102 < v6487; vLN1102++) {
          const v6488 = vA350[vLN1102];
          const v6489 = vA350[vLN1102 + 1];
          v6475.addFace(v6486[0], v6488[0], v6489[0], v6486[1], v6488[1], v6489[1], v6486[2], v6488[2], v6489[2]);
        }
      } else if (v6479 === "l") {
        const v6490 = v6478.substring(1).trim().split(" ");
        let vA351 = [];
        const vA352 = [];
        if (v6478.indexOf("/") === -1) {
          vA351 = v6490;
        } else {
          for (let vLN01034 = 0, v6491 = v6490.length; vLN01034 < v6491; vLN01034++) {
            const v6492 = v6490[vLN01034].split("/");
            if (v6492[0] !== "") {
              vA351.push(v6492[0]);
            }
            if (v6492[1] !== "") {
              vA352.push(v6492[1]);
            }
          }
        }
        v6475.addLineGeometry(vA351, vA352);
      } else if (v6479 === "p") {
        const v6493 = v6478.slice(1).trim();
        const v6494 = v6493.split(" ");
        v6475.addPointGeometry(v6494);
      } else if ((vA349 = v6428.exec(v6478)) !== null) {
        const v6495 = (" " + vA349[0].slice(1).trim()).slice(1);
        v6475.startObject(v6495);
      } else if (v6430.test(v6478)) {
        v6475.object.startMaterial(v6478.substring(7).trim(), v6475.materialLibraries);
      } else if (v6429.test(v6478)) {
        v6475.materialLibraries.push(v6478.substring(7).trim());
      } else if (v6431.test(v6478)) {
        console.warn("THREE.OBJLoader: Rendering identifier \"usemap\" not supported. Textures must be defined in MTL files.");
      } else if (v6479 === "s") {
        vA349 = v6478.split(" ");
        if (vA349.length > 1) {
          const v6496 = vA349[1].trim().toLowerCase();
          v6475.object.smooth = v6496 !== "0" && v6496 !== "off";
        } else {
          v6475.object.smooth = true;
        }
        const v6497 = v6475.object.currentMaterial();
        if (v6497) {
          v6497.smooth = v6475.object.smooth;
        }
      } else {
        if (v6478 === "\0") {
          continue;
        }
        console.warn("THREE.OBJLoader: Unexpected line: \"" + v6478 + "\"");
      }
    }
    v6475.finalize();
    const v6498 = new THREE.Group();
    v6498.materialLibraries = [].concat(v6475.materialLibraries);
    const v6499 = v6475.objects.length !== 1 || v6475.objects[0].geometry.vertices.length !== 0;
    if (v6499 === true) {
      for (let vLN01035 = 0, v6500 = v6475.objects.length; vLN01035 < v6500; vLN01035++) {
        const v6501 = v6475.objects[vLN01035];
        const v6502 = v6501.geometry;
        const v6503 = v6501.materials;
        const v6504 = v6502.type === "Line";
        const v6505 = v6502.type === "Points";
        let v6506 = false;
        if (v6502.vertices.length === 0) {
          continue;
        }
        const v6507 = new THREE.BufferGeometry();
        v6507.setAttribute("position", new THREE.Float32BufferAttribute(v6502.vertices, 3));
        if (v6502.normals.length > 0) {
          v6507.setAttribute("normal", new THREE.Float32BufferAttribute(v6502.normals, 3));
        }
        if (v6502.colors.length > 0) {
          v6506 = true;
          v6507.setAttribute("color", new THREE.Float32BufferAttribute(v6502.colors, 3));
        }
        if (v6502.hasUVIndices === true) {
          v6507.setAttribute("uv", new THREE.Float32BufferAttribute(v6502.uvs, 2));
        }
        const vA353 = [];
        for (let vLN01036 = 0, v6508 = v6503.length; vLN01036 < v6508; vLN01036++) {
          const v6509 = v6503[vLN01036];
          const v6510 = v6509.name + "_" + v6509.smooth + "_" + v6506;
          let v6511 = v6475.materials[v6510];
          if (this.materials !== null) {
            v6511 = this.materials.create(v6509.name);
            if (v6504 && v6511 && !(v6511 instanceof THREE.LineBasicMaterial)) {
              const v6512 = new THREE.LineBasicMaterial();
              THREE.Material.prototype.copy.call(v6512, v6511);
              v6512.color.copy(v6511.color);
              v6511 = v6512;
            } else if (v6505 && v6511 && !(v6511 instanceof THREE.PointsMaterial)) {
              const v6513 = new THREE.PointsMaterial({
                size: 10,
                sizeAttenuation: false
              });
              THREE.Material.prototype.copy.call(v6513, v6511);
              v6513.color.copy(v6511.color);
              v6513.map = v6511.map;
              v6511 = v6513;
            }
          }
          if (v6511 === undefined) {
            if (v6504) {
              v6511 = new THREE.LineBasicMaterial();
            } else if (v6505) {
              v6511 = new THREE.PointsMaterial({
                size: 1,
                sizeAttenuation: false
              });
            } else {
              v6511 = new THREE.MeshPhongMaterial();
            }
            v6511.name = v6509.name;
            v6511.flatShading = v6509.smooth ? false : true;
            v6511.vertexColors = v6506;
            v6475.materials[v6510] = v6511;
          }
          vA353.push(v6511);
        }
        let v6514;
        if (vA353.length > 1) {
          for (let vLN01037 = 0, v6515 = v6503.length; vLN01037 < v6515; vLN01037++) {
            const v6516 = v6503[vLN01037];
            v6507.addGroup(v6516.groupStart, v6516.groupCount, vLN01037);
          }
          if (v6504) {
            v6514 = new THREE.LineSegments(v6507, vA353);
          } else if (v6505) {
            v6514 = new THREE.Points(v6507, vA353);
          } else {
            v6514 = new THREE.Mesh(v6507, vA353);
          }
        } else if (v6504) {
          v6514 = new THREE.LineSegments(v6507, vA353[0]);
        } else if (v6505) {
          v6514 = new THREE.Points(v6507, vA353[0]);
        } else {
          v6514 = new THREE.Mesh(v6507, vA353[0]);
        }
        v6514.name = v6501.name;
        v6498.add(v6514);
      }
    } else if (v6475.vertices.length > 0) {
      const v6517 = new THREE.PointsMaterial({
        size: 1,
        sizeAttenuation: false
      });
      const v6518 = new THREE.BufferGeometry();
      v6518.setAttribute("position", new THREE.Float32BufferAttribute(v6475.vertices, 3));
      if (v6475.colors.length > 0 && v6475.colors[0] !== undefined) {
        v6518.setAttribute("color", new THREE.Float32BufferAttribute(v6475.colors, 3));
        v6517.vertexColors = true;
      }
      const v6519 = new THREE.Points(v6518, v6517);
      v6498.add(v6519);
    }
    return v6498;
  }
}